'use strict';

class DeadDurationSelector {
  constructor($timeout) {
    'ngInject';

    this.$timeout = $timeout;

    this.restrict = 'E';
    this.require = 'ngModel';
    this.scope = {
      ngModel: '=',
      min: '=',
      max: '='
    };
    this.template = require('./dead_duration_selector.html');
  }

  link(scope) {
    this.loaded = false;
    const min = scope.min | 0;
    const max = scope.max | 20;
    const options = [];
    for (let i=min; i <= max; i++) {
      options.push(i);
    }
    scope.options = options;

    scope.$watch('ngModel', (newValue) => {
      // NaN === NaN -> false を利用してNaNを判定する
      if (newValue == null || newValue !== newValue) { return; }
      if (this.loaded) { return; }

      const value = newValue / 60;
      this.$timeout(() => {
        scope.value = value + '';
      });
      this.loaded = true;
    });

    scope.$watch('value', (newValue) => {
      scope.ngModel = newValue * 60;
    });
  }
}

export default angular.module('leptonApp.durationSelector', [])
  .directive('durationSelector', ['$timeout', ($timeout) => new DeadDurationSelector($timeout)])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/dead_duration_selector/dead_duration_selector.directive.js